require('rc-slider/assets/index.css');
require('./RASingleSlider.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Slider = require('rc-slider').default;
const classNames = require('classnames');
// @ components
const RASingleSliderHandle = require('./RASingleSliderHandle/RASingleSliderHandle');

class RASingleSlider extends React.Component {
    constructor() {
        super();
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(values) {
        this.props.onChange(values);
    }

    buildHandle(props) {
        return <RASingleSliderHandle {...props} />;
    }

    buildRASingleSlider() {
        const { disabled, max, min, step, value } = this.props;
        const className = classNames('ra-single-slider__rc-slider', {
            'ra-single-slider__rc-slider--is-disabled': !!disabled,
        });

        return (
            <Slider
                step={step}
                className={className}
                min={min}
                max={max}
                onChange={this.handleOnChange}
                value={value}
                handle={this.buildHandle}
                disabled={disabled}
            />
        );
    }

    render() {
        const { disabled, max, min, step, value } = this.props;
        const slider = this.buildRASingleSlider();

        return (
            <div className="ra-single-slider__container">
                <div className="ra-single-slider">
                    <div className="ra-single-slider__slider-box hidden-xs">{slider}</div>
                </div>
                <div className="ra-single-slider__loose visible-xs">
                    <Slider
                        disabled={disabled}
                        dots
                        max={max}
                        min={min}
                        onChange={this.handleOnChange}
                        step={step}
                        value={value}
                    />
                </div>
            </div>
        );
    }
}

RASingleSlider.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    minLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    onChange: PropTypes.func,
    showTooltip: PropTypes.bool,
    step: PropTypes.number,
    disabled: PropTypes.bool,
};

RASingleSlider.defaultProps = {
    onChange: function () {},
    showTooltip: true,
    step: 5,
};

module.exports = RASingleSlider;
